import React, { useState } from 'react';
import { Link, useLocation, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './Auth.css';

export default function Login() {
  const { user, login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  // Already logged in → bounce to the page they came from, or to /market-news.
  if (user) return <Navigate to={location.state?.from || '/market-news'} replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(username.trim(), password);
      navigate(location.state?.from || '/market-news', { replace: true });
    } catch (err) {
      // Show whatever the server said, otherwise a generic message.
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={onSubmit}>
        <h1 className="auth-title">Tapebrief</h1>
        <p className="auth-subtitle">Sign in to continue</p>
        <label className="auth-label">
          <span>Username</span>
          <input
            type="text" autoComplete="username" autoFocus required
            value={username} onChange={e => setUsername(e.target.value)}
          />
        </label>
        <label className="auth-label">
          <span>Password</span>
          <input
            type="password" autoComplete="current-password" required
            value={password} onChange={e => setPassword(e.target.value)}
          />
        </label>
        {error && <div className="auth-error">{error}</div>}
        <button type="submit" className="auth-btn" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
        <p className="auth-foot">
          No account yet? <Link to="/signup">Create one</Link>
        </p>
      </form>
    </div>
  );
}
